import { useStore } from '@xyflow/react'
import type { ReactNode } from 'react'

interface ZoomScaledProps {
  children: ReactNode
  // Must match the side the panel opens toward so it scales away from its
  // anchor: 'top left' for bottom-placed panels, 'left center' for right-placed.
  origin?: string
}

/** Canvas-anchored floating panels portal to document.body, which escapes the
 * react-flow viewport transform — without this wrapper they keep a fixed
 * screen size while the canvas (and inline panels like the drag-out menu)
 * scale with zoom. */
export const ZoomScaled = ({ children, origin = 'top left' }: ZoomScaledProps) => {
  const zoom = useStore((state) => state.transform[2])
  return <div style={{ transform: `scale(${zoom})`, transformOrigin: origin }}>{children}</div>
}
